module.exports = __webpack_public_path__ + "static/media/Layers.5d81cea7.svg";